import { render, staticRenderFns } from "./pages11.vue?vue&type=template&id=323dbef8&scoped=true&"
import script from "./pages11.vue?vue&type=script&lang=js&"
export * from "./pages11.vue?vue&type=script&lang=js&"
import style0 from "./pages11.vue?vue&type=style&index=0&id=323dbef8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323dbef8",
  null
  
)

export default component.exports